import { Chip, Stack, Typography, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";

const SSPAssetList = ({ data }: any) => {
  return (
    <Stack spacing={1}>
      <Typography variant="body2" fontWeight={600}>
        Assets: <Tooltip title={"Showing : Asset Type (if available) - Asset Name - Asset Tag"} arrow 
        placement="right"
        componentsProps={{
      tooltip: {
      sx: {
        maxWidth: 500, 
        fontSize: "13px",
      },
    },
  }}>
      <IconButton size="small">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
      </Typography>

      <Divider />

      {data?.length > 0 ? (
        data.map((item: any, index: number) => (
          <Stack key={item.id} direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2" fontWeight={500}>
              {`${index + 1}.`}
            </Typography>

            <Chip 
              label={
                item?.assetType
                  ? `${item?.assetType} - ${item?.assetName} - ${item?.assetTag}`
                  : `${item?.assetName} - ${item?.assetTag}`
              }
              sx={{
                width: "fit-content",
                backgroundColor: "#e3f2fd",
                color: "#0d47a1",
                fontWeight: 500,
              }}
            />
          </Stack>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          No Assets
        </Typography>
      )}
    </Stack>
  );
};

export default SSPAssetList;